/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Stage_SlugInputs */

const cs_field_stage_slug = /** @type {(inputs: Field_Stage_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug fáze`)
};

const en_field_stage_slug = /** @type {(inputs: Field_Stage_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage slug`)
};

/**
* | output |
* | --- |
* | "Stage slug" |
*
* @param {Field_Stage_SlugInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_stage_slug = /** @type {((inputs?: Field_Stage_SlugInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Stage_SlugInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_stage_slug(inputs)
	return cs_field_stage_slug(inputs)
});